// tslint:disable:no-unsafe-any (autogenerated)
const timers = {};

// tslint:disable-next-line:typedef no-default-export (autogenerated)
export default function(timerId: string, message: string) {
    if (NODE_ENV !== 'development') {
        return;
    }
    try {
        console.log('[BOOTSTRAP] ' + message);
        if (timers[timerId]) {
            console.timeEnd('[BOOTSTRAP] ' + timerId);
        } else {
            timers[timerId] = true;
            console.time('[BOOTSTRAP] ' + timerId);
        }
    } catch (error) {
        console.error('[BOOTSTRAP] ' + error.toString());
    }
}
